import React from 'react';
import { NavLink } from 'react-router-dom';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';

const TABS = [
  ['/settings', 'Workspace'],
  ['/business-profile', 'Business profile'],
  ['/business-settings', 'Business settings'],
  ['/business-hours', 'Business hours', 'business:manage'],
  ['/ai-usage', 'AI usage', 'billing:read'],
];

/** Tab strip shared by the three Settings screens, so the business profile form is reachable from the sidebar's Settings. */
export default function SettingsTabs() {
  const { can } = useWorkspace();
  return (
    <div className="d-flex flex-wrap gap-2 mb-4" role="tablist" aria-label="Settings sections">
      {TABS.filter(([, , permission]) => !permission || can(permission)).map(([to, label]) => (
        <NavLink key={to} to={to} end role="tab" className={({ isActive }) => `btn btn-sm ${isActive ? 'btn-dark' : 'btn-outline-secondary'}`}>{label}</NavLink>
      ))}
    </div>
  );
}
